import React from 'react';
import PropTypes from 'prop-types';

import Messages from '../../../fragments/messages';
import ValidateDialog from '../../../../components/validate-dialog';

import Summary from './summary';

import style from './style.css';

export default class DialogPrompt extends React.Component {

  static propTypes = {
    rawDataCollection: PropTypes.object.isRequired,
    showDialog: PropTypes.bool.isRequired,
    showSubmit: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  render() {
    const {rawDataCollection} = this.props;

    const messages = rawDataCollection.messages(
      'rawSequences', true, false, false);
    const noMessage = (messages.length === 0);

    return (
      <ValidateDialog {...this.props}>
        <Summary
         rawDataCollection={rawDataCollection} />
        {noMessage?
          <div className={style['pass-message']}>
           Passed validation, no critical error.
          </div>:
          <React.Fragment>
            <div>
              Please fix these errors below:
            </div>
            <Messages
             messages={messages}
             noIndent
             scrollable
            />
          </React.Fragment>
        }
      </ValidateDialog>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/gtable_seq/dialog-prompt.js